import types from '../mutation-types';
import PartnersAPI from '../../api/partners';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: { isFetching: false, isCreating: false, isUpdating: false },
};

export const getters = {
  getPartners: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_PARTNERS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await PartnersAPI.get();
      commit(types.SET_PARTNERS, data.partners || []);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_PARTNERS_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, partner) => {
    commit(types.SET_PARTNERS_UI_FLAG, { isCreating: true });
    try {
      const { data } = await PartnersAPI.create({ partner });
      commit(types.ADD_PARTNER, data);
      return data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_PARTNERS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...partner }) => {
    commit(types.SET_PARTNERS_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await PartnersAPI.update(id, { partner });
      commit(types.EDIT_PARTNER, data);
      return data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_PARTNERS_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_PARTNERS]($state, data) {
    $state.records = data;
  },
  [types.ADD_PARTNER]($state, data) {
    $state.records = [...$state.records, data];
  },
  [types.EDIT_PARTNER]($state, data) {
    $state.records = $state.records.map(p => (p.id === data.id ? data : p));
  },
  [types.SET_PARTNERS_UI_FLAG]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default { namespaced: true, state, getters, actions, mutations };
